import { Tabs } from "@mantine/core";
import React from "react";
import JobSeekerFollowedBy from "./JobSeekerFollowedBy";
import JobSeekerFollowing from "./JobSeekerFollowing";

const ConnectionJobSeeker = () => {
  return (
    <Tabs
      defaultValue="followers"
      color={"red.9"}
      styles={{
        tabLabel: {
          fontSize: "1rem",
        },
      }}
    >
      <Tabs.List>
        <Tabs.Tab value="followers">Followers</Tabs.Tab>
        <Tabs.Tab value="following">Following</Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="followers" pt="xs">
        <JobSeekerFollowedBy />
      </Tabs.Panel>

      <Tabs.Panel value="following" pt="xs">
        <JobSeekerFollowing />
      </Tabs.Panel>
    </Tabs>
  );
};

export default ConnectionJobSeeker;
